import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAppoinmentAction,
  getAppointmentQueueFilterCountsAction,
  updateAppoinmentPartialStatusAction,
  updateAppoinmentStatusAction,
} from "../../../redux/actions/AppoinmentAction";
import moment from "moment";
import { getSnackbarSuccess } from "../../../Utils/helper";

export const PartialShow = ({
  setPartialShow,
  partialShow,
  searchFilter,
  apiParams,
}) => {
  const [test, setTest] = useState([]);
  const [remarks,setRemarks]= useState("")
  const appoinmentReducer = useSelector(
    (state) => state?.AppoinmentReducer?.partialTestDetail
  );
  const dispatch = useDispatch();
  const handleSubmit = () => {
    if (appoinmentReducer?.length === test?.length) {
      getSnackbarSuccess(
        "info",
        "You can not select all Tests for Partial Show",
        dispatch
      );
    } else {
      const res = dispatch(
        updateAppoinmentPartialStatusAction({
          valueType: partialShow?.data?.valueType,
          appointmentId: partialShow?.data?.appointmentId,
          DCConfirmationFlag: "Z",
          Validate: false,
          AppointmentDate: moment(
            partialShow?.data?.appointmentDateTime
          ).format("YYYY-MM-DD hh:mm A"),
          AppointmentStatusId: partialShow?.data?.appointmentstatusid,
          testDetails: test,
          remarks:remarks
        })
      ).then((res) => {
        if (res?.data?.status === true) {
          setTimeout(()=>{
            dispatch(getAppointmentQueueFilterCountsAction({ ...searchFilter, ...apiParams }));
            dispatch(getAppoinmentAction({ ...searchFilter, ...apiParams }));
          },1000)
          getSnackbarSuccess("success", res?.data?.message, dispatch);
          document.getElementById("closePartialShow").click();
          setRemarks("")
        } else {
          getSnackbarSuccess("info", res?.data?.message, dispatch);
        }
      });
    }
  };
  return (
    <div class="modal-content">
      <div
        className="d-flex justify-content-between border-bottom modalHeader"
        style={{ borderRadius: "10px 10px 0px 0px" }}
      >
        <h4 className="font-bold text-black">Partial Show</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          data-bs-dismiss="modal"
          id="closePartialShow"
          onClick={() =>{
            setTest([])
            setRemarks("")
          }}
        ></button>
      </div>
      {/* <h5 className="font-bold text-black">List of item in your package</h5> */}
      <div
        className="modal-body "
        style={{ padding: "0 30px", maxHeight: "350px", overflow: "auto" }}
      >
        <div className="select-time-interval" style={{ height: "100%" }}>
          {appoinmentReducer?.map((ele, index) => (
            <div className="d-flex gap-3">
              <div style={{ fontSize: "15px", padding: "3px" }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={test?.some((element) => element === ele)}
                  onClick={(e) => {
                    if (e.target.checked) {
                      setTest([...test, ele]);
                    } else {
                      let arr = test.filter((item) => item !== ele);
                      setTest(arr);
                    }
                  }}
                />
              </div>
              <label style={{ fontSize: "13px", padding: "3px" }}>
                {ele?.tests}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="col-lg-12 col-md-12 p-3 modal-body">
        <label  className="col-form-label" style={{fontWeight:"600"}}>
          Remarks
        </label>
        <textarea
          required
          className="form-control form-select-admin inputbgavanish"
          rows="3"
          cols="30"
          style={{backgroundColor:"#eeeeee"}}
          value={remarks}
          // onKeyPress={(e) => {
          //   const re = /^[a-zA-Z\s]*$/;
          //   if (e.target.value.trim() === "" && e.key === " ") {
          //     e.preventDefault();
          //     return;
          //   }
          // }}
          onChange={(e) => setRemarks(e.target.value)}
        ></textarea>
      </div>
      <div className="modal-footer modal-footer-admin d-flex flex-row-reverse accept-reject-btns  accept-reject-btns-admin bottom-0 ">
        <div>
          <button
            type="button"
            className="savedetails"
            disabled={test?.length < 1}
            //   aria-label="Close"
            //   data-bs-dismiss="modal"
            onClick={() => {
              handleSubmit();
            }}
          >
           Submit
          </button>
        </div>
      </div>
    </div>
  );
};
